import { render, staticRenderFns } from "./TollModal.vue?vue&type=template&id=585d59ec&"
import script from "./TollModal.vue?vue&type=script&lang=js&"
export * from "./TollModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports